import { Injectable } from '@angular/core';
import { PaymentResponse } from '../interfaces/payment';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  constructor(private https: HttpClient) { }

  payWithPagueloFacil(locator:string, cardInformation: any){
    return this.https.post<PaymentResponse>(environment.apiUrl+`payments/paguelofacil/${locator}`, cardInformation );
  }

  pay(locator:string, paymentData: { cardInformation: any }){
    return this.https.post<PaymentResponse>(environment.apiUrl+`payments/auth/${locator}`, paymentData );
  }

  validateApplePayMerchant(validationURL: string) {
    return this.https.post<any>(environment.apiUrl + `payments/apple-pay/validate-merchant`, { validationURL });
  }

  payWithApplePay(locator: string, applePayToken: any) {
    return this.https.post<any>(environment.apiUrl + `payments/apple-pay/auth/${locator}`, { applePayToken });
  }
}
